<script>
import { mapGetters } from 'vuex';
import LoadIndicator from '../components/LoadIndicator';
import PortraitPhoto from '../components/PortraitPhoto';

export default {
    name: 'ContributorPage',
    components: {
        LoadIndicator,
        PortraitPhoto,
    },
    props: {
        slug: String,
    },
    mounted() {
        this.init(this.slug);
    },
    methods: {
        init(slug) {
            this.$store.dispatch('selectContributorForDetail', slug);
        },
        onContactClick() {
            event.preventDefault();
            this.$store.dispatch('openOverlayPage', { 
                component: 'ContactPage', 
                props: { 
                    slug: this.contributor.slug 
                }
            });
        },
        onAnswersClick() {
            event.preventDefault();
            this.$store.dispatch('closeOverlay');
            this.$router.push({ path: this.$t('contributorQuestions.url') + '/' + this.contributor.slug })
        }
    },
    computed: {
        ...mapGetters({
            contributor: 'getSelectedDetailContributor',
            isLoading: 'getContributorsIsLoading',
        }),
    },
    beforeDestroy() {
        this.$store.dispatch('selectContributorForDetail', null);
    },
};
</script>

<template>
    <section class="contributor-page" v-on:keyup.esc="onClose()">
        <div class="contributor-page__content-wrapper" v-if="!isLoading && contributor">
            <aside class="contributor-page__aside">
                <portrait-photo v-bind:photo="contributor.photo" v-bind:name="contributor.slug" size="large" />
                <a 
                    href="#"
                    v-on:click="onContactClick($event)"
                    class="contributor-page__link-contact" 
                    v-if="contributor.email">
                        {{ $t('contributorPage.contact') }}
                </a>
            </aside>

            <article class="contributor-page__main">
                <h1 class="contributor-page__title page-title" v-html="contributor.title.rendered"></h1>
                <h2 class="contributor-page__role">{{ contributor.role }}</h2>
                <div class="contributor-page__content" v-html="contributor.bio"></div>
            </article>
        </div>

        <load-indicator v-if="isLoading"></load-indicator>

    </section>
</template>

<style lang="scss">
.contributor-page {
    color: $color-light;
}
.contributor-page__content-wrapper {
    display: flex;
    max-width: 100.8rem;
    margin: 12.6rem auto 0;

    @include breakpoint('md-down') {
        max-width: 78.4rem;
    }

    @include breakpoint('sm-down') {
        display: block;
        box-sizing: border-box;
        width: 100%;
        max-width: 48rem;
        padding: 7.2rem 1.6rem;
        margin: 0 auto;
    }
}
.contributor-page__aside {
    margin-right: 6.6rem;

    @include breakpoint('sm-down') {
        margin-right: 0;
    }
}
.contributor-page__main {
    max-width: 48rem;
    margin-right: 23.8rem;

    @include breakpoint('md-down') {
        margin-right: 0;
    }
}
.contributor-page__title {
    margin: 5.6rem 0 0.8rem;

    @include breakpoint('sm-down') {
        margin: 1.6rem 0 0 0;
    }
}
.contributor-page__role {
    font-size: 2.2rem;
    font-weight: 300;
    letter-spacing: 0.04rem;
    line-height: 1.1;
    margin: 0.48rem 0 7rem;

    @include breakpoint('sm-down') {
        margin: 0.48rem 0 4.8rem;
    }
}
.contributor-page__content p {
    font-size: 1.8rem;
    margin: 0 0 2.4rem;
    line-height: 1.667;
}
.contributor-page__link-contact,
.contributor-page__link-answers {
    display: block;
    margin: 4.8rem 0 0 1.6rem;
    font-size: 1.8rem;
    color: $color-blue;
    letter-spacing: 0.052rem;
    text-transform: uppercase;
    text-decoration: none;

    @include breakpoint('sm-down') {
        margin: 4.8rem 0 3.2rem 0;
    }
}
.contributor-page__link-contact:before,
.contributor-page__link-answers:before {
    content: "";
    display: inline-block;
    width: 1.92rem; height: 1.44rem;
    margin-right: 0.64rem;
    background: center url('~@/assets/images/ico-contact-overlay.svg') no-repeat;
}
.contributor-page__link-answers:before {
    height: 1.6rem;
    background: center url('~@/assets/images/ico-answers-light.svg') no-repeat;
}
</style>
